export default __webpack_public_path__ + "static/media/safety-net.45567c36.svg";